import { cameraTypeList } from '../../utils/constant';
import { disableOptions } from '../vulcanPricing/utils/utils';
import { secureBusinessOffersVulcan } from '../vulcanPricing/secureBusiness/secureBusinessFieldNames';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

// This function takes opt arguments which are equipment section fields
export const getControlIncludedCameraTotal = opt => {
  let returnObj = 0;
  const formObjectKeys = Object.keys(opt);
  const sectionSum = formObjectKeys
    .filter(k => cameraTypeList.includes(opt[k].productType))
    .reduce((acc, k) => acc + parseInt(opt[k].value || 0, 10), 0);
  returnObj = sectionSum;

  return returnObj; // Ensure returnObj is always returned
};

export const SecureBusinessHelpers = ({ fieldName, formFields }) => {
  const locale = getLocale();
  const {
    vulcanWebform: {
      vulTenDollarBundleDiscountTSB,
      vulTwentyDollarMonthlyDiscountTSB,
      vulWaivedInstallationFeeOptionTSB,
    }
  } = locale === 'en-US' ? EN : FR;

  if (fieldName === secureBusinessOffersVulcan) {
    if (!formFields[secureBusinessOffersVulcan].value) {
      formFields[secureBusinessOffersVulcan].value = [
        vulTenDollarBundleDiscountTSB,
        vulTwentyDollarMonthlyDiscountTSB,
        vulWaivedInstallationFeeOptionTSB
      ];
    }
    disableOptions(
      formFields[secureBusinessOffersVulcan].options,
      [vulTenDollarBundleDiscountTSB, vulTwentyDollarMonthlyDiscountTSB],
      true
    );
  }
};
